import { useStore } from "@tanstack/react-store";
import { Store } from "@tanstack/react-store";
import { useCallback } from "react";
import type { StoreSelector, StoreUpdater } from "./storeFactory";

/**
 * Type-safe hook for selecting from a store
 */
export function useStoreSelector<TState, TSelected>(
  store: Store<TState>,
  selector: StoreSelector<TState, TSelected>,
): TSelected {
  return useStore(store, selector);
}

/**
 * Type-safe hook for dispatching store updates
 */
export function useStoreActions<TState>(store: Store<TState>) {
  const update = useCallback(
    (updater: StoreUpdater<TState>) => {
      store.setState(updater);
    },
    [store],
  );

  const setState = useCallback(
    (newState: TState) => {
      store.setState(() => newState);
    },
    [store],
  );

  return { update, setState };
}
